import type { FC } from "react";
import React from "react";
import Tooltip from "@arenko-group/arenko-ui/dist/components/Tooltip";
import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import IconButton from "@mui/material/IconButton";

type NavMenuToggleProps = {
  onClick: () => void;
  expanded?: boolean;
  testId?: string;
};

const NavMenuToggle: FC<NavMenuToggleProps> = ({
  onClick: menuToggle,
  expanded: menuExpanded,
  testId = "nav-menu-toggle",
}) => {
  const MenuToggleIcon = menuExpanded ? MenuOpenIcon : MenuIcon;
  const action = menuExpanded ? "Collapse" : "Expand";

  return (
    <Tooltip placement="bottom-end" title={`${action} menu by pressing key [`}>
      <IconButton
        data-testid={testId}
        onClick={menuToggle}
        aria-label={`${action} menu`}
        sx={{ color: "currentColor" }}
      >
        <MenuToggleIcon />
      </IconButton>
    </Tooltip>
  );
};

export default NavMenuToggle;
